module.exports = __webpack_public_path__ + "img/HeadExtraction04.ab73df88.png";